import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Placement } from '../../../interfaces/placement';

@Component({
	selector: 'placement-details-metadata',
	templateUrl: './placement-details-metadata.component.html',
	styleUrls: ['./placement-details-metadata.component.scss']
})

export class PlacementDetailsMetadataComponent implements OnInit {

	@Input() placement: Placement;
	@Input() form: NgForm;

	constructor() { }

	ngOnInit() { }
}
